import axios from "axios";

// export default axios.create({
//     baseUrl: "http://65.20.73.28:8090//"
// });

// export const baseUrl="http://65.20.73.28:8090/"

// export const baseUrl = "https://propertysearch.ai/api";
export const baseUrl = "https://admin.propertysearch.ai/api";
export const baseUrlPropertydemat = "https://propertydemat.com/api";
export const baseUrlCyperts = "https://cyperts.xyz/api";
export const baseUrlLms = "https://lms.propertysearch.ai";
// export const baseUrlCyperts = "https://cyperts.xyz/api";
export const baseUrl28 = "http://65.20.73.28:8090/api";

// Domain Shift

// export const baseUrl = "http://65.20.71.33:8080/api";
// export const baseUrlPropertydemat = "http://65.20.71.33:8080/api";
// export const baseUrlCyperts = "http://65.20.71.33:8080/api";
// export const baseUrlLms = "https://lms.propertysearch.ai";
// // export const baseUrlCyperts = "http://cyperts.xyz/api";
// export const baseUrl28 = "http://65.20.73.28:8090/api";
